"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetersPage = MetersPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var onboarding_gaps_prompt_1 = require("../../../components/onboarding-gaps-prompt");
var table_styles_1 = require("../../../components/table-styles");
var building_1 = require("../../../features/apis/building");
var building_area_1 = require("../../../features/apis/building-area");
var meter_1 = require("../../../features/apis/meter");
var meter_status_change_dialog_1 = require("../../../components/dialogs/meter-status-change-dialog");
var service_1 = require("../../../features/apis/service");
var tenant_1 = require("../../../features/apis/tenant");
var content_dialog_1 = require("../../../features/thunks/content-dialog");
var hooks_1 = require("../../../store/hooks");
var to_title_case_1 = require("../../../utils/to-title-case");
var constants_1 = require("./constants");
var tile_filter_1 = require("./tile-filter");
var meter_form_1 = require("./meter-form");
function getMeterTypeColor(type) {
    var t = type.toLowerCase();
    if (t === "power" || t === "electrical")
        return "warning";
    if (t === "water")
        return "secondary";
    return "warning";
}
function MetersPage() {
    var _this = this;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_router_dom_1.useSearchParams)(), searchParams = _a[0], setSearchParams = _a[1];
    var _b = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }), clientId = _b.clientId, userId = _b.userId;
    var createMeter = (0, meter_1.useCreateMeterMutation)()[0];
    var _c = (0, meter_1.useUpdateMeterMutation)(), updateMeter = _c[0], isChangingStatus = _c[1].isLoading;
    // The server's reason for refusing a status change, shown inside the dialog.
    var _d = (0, react_3.useState)(null), statusChangeError = _d[0], setStatusChangeError = _d[1];
    var _e = (0, react_3.useState)(null), statusChangeMeter = _e[0], setStatusChangeMeter = _e[1];
    var autoCreateTriggered = (0, react_3.useRef)(false);
    var _f = (0, react_3.useState)(""), searchQuery = _f[0], setSearchQuery = _f[1];
    var _g = (0, react_3.useState)(""), debouncedSearch = _g[0], setDebouncedSearch = _g[1];
    /*
     * Tile filters hold the keys currently INCLUDED — everything selected is the resting state and means
     * no filtering, which is why Erik's spec needs no "All" tile. See tile-filter.tsx.
     */
    var _h = (0, react_3.useState)(["in-use", "dormant", "removed", "inactive"]), statusKeys = _h[0], setStatusKeys = _h[1];
    var _j = (0, react_3.useState)(["Power", "Water"]), typeKeys = _j[0], setTypeKeys = _j[1];
    var _k = (0, react_3.useState)(["area", "building"]), levelKeys = _k[0], setLevelKeys = _k[1];
    var _l = (0, react_3.useState)(["Consumption", "Check", "Production/Bulk", "Not set"]), purposeKeys = _l[0], setPurposeKeys = _l[1];
    var _m = (0, react_3.useState)(["Assigned", "Unassigned"]), assignmentKeys = _m[0], setAssignmentKeys = _m[1];
    var _o = (0, react_3.useState)([]), serviceKeys = _o[0], setServiceKeys = _o[1];
    var _p = (0, react_3.useState)("all"), makeFilter = _p[0], setMakeFilter = _p[1];
    var _q = (0, react_3.useState)("all"), modelFilter = _q[0], setModelFilter = _q[1];
    var _r = (0, react_3.useState)("all"), rateCardFilter = _r[0], setRateCardFilter = _r[1];
    var _s = (0, react_3.useState)("all"), buildingFilter = _s[0], setBuildingFilter = _s[1];
    var _t = (0, react_3.useState)("all"), areaFilter = _t[0], setAreaFilter = _t[1];
    var _u = (0, react_3.useState)("all"), tenantFilter = _u[0], setTenantFilter = _u[1];
    var _v = (0, react_3.useState)(1), page = _v[0], setPage = _v[1];
    var _w = (0, react_3.useState)(10), rowsPerPage = _w[0], setRowsPerPage = _w[1];
    // Debounce search input to avoid excessive API calls
    (0, react_3.useEffect)(function () {
        var timer = setTimeout(function () {
            setDebouncedSearch(searchQuery);
            setPage(1);
        }, 400);
        return function () { return clearTimeout(timer); };
    }, [searchQuery]);
    // Fetch buildings for filter dropdown and form
    var buildingsResponse = (0, building_1.useFetchClientBuildingsQuery)({ clientId: clientId, page: 1, limit: 100 }, { skip: !clientId }).data;
    var buildings = (0, react_3.useMemo)(function () { var _a; return ((_a = buildingsResponse === null || buildingsResponse === void 0 ? void 0 : buildingsResponse.content) === null || _a === void 0 ? void 0 : _a.buildings) || []; }, [buildingsResponse]);
    // Fetch areas for filter dropdown and form (filtered by building when selected)
    var areasResponse = (0, building_area_1.useSearchBuildingAreasQuery)({
        clientId: clientId,
        buildingId: buildingFilter !== "all" ? buildingFilter : undefined,
        page: 1,
        limit: 1000,
    }, { skip: !clientId }).data;
    var areas = (0, react_3.useMemo)(function () { var _a; return ((_a = areasResponse === null || areasResponse === void 0 ? void 0 : areasResponse.content) === null || _a === void 0 ? void 0 : _a.buildingAreas) || []; }, [areasResponse]);
    // Fetch tenants for filter dropdown
    var tenantsResponse = (0, tenant_1.useFetchClientTenantsQuery)({ clientId: clientId, page: 1, limit: 1000 }, { skip: !clientId }).data;
    var tenants = (0, react_3.useMemo)(function () { var _a; return ((_a = tenantsResponse === null || tenantsResponse === void 0 ? void 0 : tenantsResponse.content) === null || _a === void 0 ? void 0 : _a.tenants) || []; }, [tenantsResponse]);
    // Server-side search, filter, and pagination
    var _x = (0, meter_1.useSearchMetersQuery)({
        clientId: clientId,
        search: debouncedSearch || undefined,
        buildingId: buildingFilter !== "all" ? buildingFilter : undefined,
        page: 1,
        limit: 1000,
    }, { skip: !clientId, refetchOnMountOrArgChange: true }), metersResponse = _x.data, isLoading = _x.isLoading, isFetching = _x.isFetching, refetch = _x.refetch;
    /*
     * Meter Management Refinements: a tile filter shows how many meters sit behind each value, and a count
     * taken from one page would change as you page through it. Three of the new groups — purpose,
     * assignment status and service type — have no server-side filter either.
     *
     * So the client's meters are fetched once and every filter, count and page is worked out below. The
     * server still does the text search and the building scope. A portfolio past a thousand meters would
     * need real server-side faceting; DEV holds 500 across three clients.
     */
    var allMeters = (0, react_3.useMemo)(function () { var _a; return ((_a = metersResponse === null || metersResponse === void 0 ? void 0 : metersResponse.content) === null || _a === void 0 ? void 0 : _a.meters) || []; }, [metersResponse]);
    // Meter Management Refinements: a production/bulk meter is assigned to one of the asset's services.
    var servicesResponse = (0, service_1.useFetchClientServicesQuery)({ clientId: clientId, page: 1, limit: 1000 }, { skip: !clientId }).data;
    var serviceOptionsForForm = (0, react_3.useMemo)(function () {
        var _a;
        return (((_a = servicesResponse === null || servicesResponse === void 0 ? void 0 : servicesResponse.content) === null || _a === void 0 ? void 0 : _a.services) || [])
            .filter(function (sv) { return sv.isActive && !sv.deleted; })
            .map(function (sv) { return ({ key: sv._id, label: sv.name, buildingId: String(sv.buildingId), serviceType: sv.serviceType }); });
    }, [servicesResponse]);
    /* Which service each meter measures, for the service-type tiles. */
    var serviceTypeById = (0, react_3.useMemo)(function () {
        var _a;
        var map = new Map();
        for (var _i = 0, _b = ((_a = servicesResponse === null || servicesResponse === void 0 ? void 0 : servicesResponse.content) === null || _a === void 0 ? void 0 : _a.services) || []; _i < _b.length; _i++) {
            var sv = _b[_i];
            map.set(String(sv._id), String(sv.serviceType));
        }
        return map;
    }, [servicesResponse]);
    var serviceTypeOf = (0, react_3.useCallback)(function (m) { var _a; return (m.serviceId ? (_a = serviceTypeById.get(String(m.serviceId))) !== null && _a !== void 0 ? _a : "None" : "None"); }, [serviceTypeById]);
    /* Mirrors isMeterAssigned on the server — these tiles must agree with what the meter screen says. */
    var assignmentOf = (0, react_3.useCallback)(function (m) {
        var _a;
        if (m.meterPurpose === "CONSUMPTION")
            return m.areaId ? "Assigned" : "Unassigned";
        if (m.meterPurpose === "PRODUCTION_BULK")
            return m.serviceId ? "Assigned" : "Unassigned";
        if (m.meterPurpose === "CHECK")
            return ((_a = m.checksMeterIds) !== null && _a !== void 0 ? _a : []).length > 0 ? "Assigned" : "Unassigned";
        return "Unassigned";
    }, []);
    var purposeOf = (0, react_3.useCallback)(function (m) { var _a; return (_a = constants_1.METER_PURPOSE_LABELS[m.meterPurpose]) !== null && _a !== void 0 ? _a : "Not set"; }, []);
    var serviceTypeValues = (0, react_3.useMemo)(function () { return Array.from(new Set(allMeters.map(function (m) { return serviceTypeOf(m); }))).sort(); }, [allMeters, serviceTypeOf]);
    // Seed the service tiles once the values are known — all selected, i.e. not filtering.
    (0, react_3.useEffect)(function () {
        if (serviceTypeValues.length && serviceKeys.length === 0)
            setServiceKeys(serviceTypeValues);
    }, [serviceTypeValues, serviceKeys.length]);
    /*
     * Every filter EXCEPT the group being counted, so each tile shows what selecting it would actually
     * return rather than a total that ignores the rest of the filters.
     */
    var passes = (0, react_3.useCallback)(function (m, skip) {
        var _a, _b, _c;
        if (skip !== "status" && !statusKeys.includes((_a = m.status) !== null && _a !== void 0 ? _a : "in-use"))
            return false;
        if (skip !== "type" && !typeKeys.includes(m.meterType))
            return false;
        if (skip !== "level" && !levelKeys.includes(m.meterLevel))
            return false;
        if (skip !== "purpose" && !purposeKeys.includes(purposeOf(m)))
            return false;
        if (skip !== "assignment" && !assignmentKeys.includes(assignmentOf(m)))
            return false;
        if (skip !== "service" && serviceKeys.length > 0 && !serviceKeys.includes(serviceTypeOf(m)))
            return false;
        if (areaFilter !== "all" && String((_b = m.areaId) !== null && _b !== void 0 ? _b : "") !== areaFilter)
            return false;
        if (tenantFilter !== "all" && String((_c = m.tenantId) !== null && _c !== void 0 ? _c : "") !== tenantFilter)
            return false;
        // Loose compare for the same reason the options are grouped loosely — see `distinct` below.
        var same = function (a, b) { return String(a !== null && a !== void 0 ? a : "").trim().toLowerCase() === b.trim().toLowerCase(); };
        if (makeFilter !== "all" && !same(m.meterMake, makeFilter))
            return false;
        if (modelFilter !== "all" && !same(m.meterModel, modelFilter))
            return false;
        if (rateCardFilter !== "all" && !same(m.rateCard, rateCardFilter))
            return false;
        return true;
    }, [statusKeys, typeKeys, levelKeys, purposeKeys, assignmentKeys, serviceKeys, areaFilter, tenantFilter, makeFilter, modelFilter, rateCardFilter, purposeOf, assignmentOf, serviceTypeOf]);
    var countBy = (0, react_3.useCallback)(function (group, valueOf, values) {
        return values.map(function (v) { return ({ key: v.key, label: v.label, count: allMeters.filter(function (m) { return valueOf(m) === v.key && passes(m, group); }).length }); });
    }, [allMeters, passes]);
    var filteredMeters = (0, react_3.useMemo)(function () { return allMeters.filter(function (m) { return passes(m); }); }, [allMeters, passes]);
    var totalItems = filteredMeters.length;
    var totalPages = Math.max(1, Math.ceil(totalItems / rowsPerPage));
    var meters = (0, react_3.useMemo)(function () { return filteredMeters.slice((page - 1) * rowsPerPage, page * rowsPerPage); }, [filteredMeters, page, rowsPerPage]);
    /*
     * Dropdown options taken from the data itself, so only values that exist are offered.
     *
     * Grouped case-insensitively and trimmed, because the same make is stored several ways: DEV holds
     * "ELSTER KENT" and "ELSTER KENT " (trailing space), "KAMSTRUP" and "Kamstrup", "HONEYWELL" and
     * "Honeywell". Listing each variant separately gives the user two identical-looking options that each
     * return half the meters. One entry per real value, and selecting it matches every spelling.
     *
     * The underlying data is still inconsistent — that is a separate clean-up — but the filter should not
     * make the user pay for it.
     */
    var distinct = function (pick) {
        var byKey = new Map();
        for (var _i = 0, allMeters_1 = allMeters; _i < allMeters_1.length; _i++) {
            var m = allMeters_1[_i];
            var raw = pick(m);
            if (!raw)
                continue;
            var label = String(raw).trim();
            if (!label)
                continue;
            var key = label.toLowerCase();
            var seen = byKey.get(key);
            // Keep the spelling that appears most often as the one worth showing.
            byKey.set(key, seen && seen.n >= 1 ? { label: seen.n >= 1 && seen.label === label ? label : seen.label, n: seen.n + 1 } : { label: label, n: 1 });
        }
        return Array.from(byKey.values())
            .map(function (v) { return v.label; })
            .sort(function (a, b) { return a.localeCompare(b); });
    };
    var makeOptions = (0, react_3.useMemo)(function () { return distinct(function (m) { return m.meterMake; }); }, [allMeters]);
    var modelOptions = (0, react_3.useMemo)(function () { return distinct(function (m) { return m.meterModel; }); }, [allMeters]);
    var rateCardOptions = (0, react_3.useMemo)(function () { return distinct(function (m) { return m.rateCard; }); }, [allMeters]);
    // Building filter options (using building IDs as keys)
    var buildingFilterOptions = (0, react_3.useMemo)(function () {
        return __spreadArray([
            { key: "all", label: "All Buildings" }
        ], buildings.map(function (b) { return ({ key: b._id, label: "".concat((0, to_title_case_1.toTitleCase)(b.name), " (").concat(b.code, ")") }); }).sort(function (a, b) { return a.label.localeCompare(b.label); }), true);
    }, [buildings]);
    // Area filter options (from areas API, filtered by building)
    var areaFilterOptions = (0, react_3.useMemo)(function () {
        return __spreadArray([{ key: "all", label: "All Areas" }], areas.map(function (a) { return ({ key: a._id, label: a.areaNumber }); }).sort(function (a, b) { return a.label.localeCompare(b.label); }), true);
    }, [areas]);
    // Tenant filter options (from tenant API)
    var tenantFilterOptions = (0, react_3.useMemo)(function () {
        return __spreadArray([{ key: "all", label: "All Tenants" }], tenants.map(function (t) { return ({ key: t._id, label: t.name }); }).sort(function (a, b) { return a.label.localeCompare(b.label); }), true);
    }, [tenants]);
    // Building options for the form (with IDs)
    var buildingOptionsForForm = (0, react_3.useMemo)(function () {
        // `code` is needed to compose a check meter name (MC&LCC-3.2), which is prefixed with it.
        return buildings.map(function (b) { return ({ key: b.name, label: (0, to_title_case_1.toTitleCase)(b.name), id: b._id, code: b.code }); }).sort(function (a, b) { return a.label.localeCompare(b.label); });
    }, [buildings]);
    // Area options for the form
    var areaOptionsForForm = (0, react_3.useMemo)(function () {
        return areas.map(function (a) { return ({ key: a._id, label: "".concat(a.areaNumber, " - ").concat((0, to_title_case_1.toTitleCase)(a.buildingName)), buildingId: a.buildingId }); });
    }, [areas]);
    var handleRefresh = function () {
        refetch();
    };
    var handleMeterSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, createMeter({
                            clientId: clientId,
                            meterType: data.meterType,
                            meterLevel: data.meterLevel,
                            serialNumber: data.serialNumber,
                            meterId: data.meterId,
                            meterLocation: data.meterLocation,
                            description: data.description,
                            meterMake: data.meterMake,
                            meterModel: data.meterModel,
                            buildingId: data.buildingId,
                            areaId: data.areaId,
                            tenantId: data.tenantId,
                            tenantName: data.tenantName,
                            effectiveConsumptionDate: data.effectiveConsumptionDate,
                            kvaRating: data.kvaRating,
                            breakerSize: data.breakerSize,
                            rateCard: data.rateCard,
                            multiplier: data.multiplier,
                            installationDate: data.installationDate,
                            isManualReading: data.isManualReading,
                            calibrationDate: data.calibrationDate,
                            nextCalibrationDate: data.nextCalibrationDate,
                            responsibleParty: data.responsibleParty,
                            isActive: data.isActive,
                            notes: data.notes,
                            // Same omission as the update path — see the note in meter-edit's buildPayload.
                            meterPurpose: data.meterPurpose,
                            serviceId: data.serviceId,
                            checksMeterIds: data.checksMeterIds,
                            phaseCount: data.phaseCount,
                            checkMeterDescription: data.checkMeterDescription,
                            checkMeterPhysicality: data.checkMeterPhysicality,
                            createdBy: userId,
                        }).unwrap()];
                case 1:
                    response = _b.sent();
                    if (response.success) {
                        (0, react_1.addToast)({
                            title: "Meter Created",
                            description: "Meter has been created successfully.",
                            color: "success",
                        });
                        return [2 /*return*/, true];
                    }
                    else {
                        (0, react_1.addToast)({
                            title: "Create Failed",
                            description: response.message || "Could not create meter.",
                            color: "danger",
                        });
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    message = ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred while creating the meter.";
                    (0, react_1.addToast)({
                        title: "Create Failed",
                        description: message,
                        color: "danger",
                    });
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleAddMeter = (0, react_3.useCallback)(function (prefill) {
        dispatch((0, content_dialog_1.showContentDialogThunk)({
            header: "Add New Meter",
            content: ((0, jsx_runtime_1.jsx)(meter_form_1.MeterForm, { onSubmit: handleMeterSubmit, mode: "create", buildingOptions: buildingOptionsForForm, areaOptions: areaOptionsForForm, existingMeters: meters.map(function (m) { return ({ _id: m._id, areaId: m.areaId, meterType: m.meterType, serialNumber: m.serialNumber, areaName: m.areaName }); }), serviceOptions: serviceOptionsForForm, onCreateService: function (buildingId) { return navigate("/dashboard/services?create=1&buildingId=".concat(buildingId)); }, initialData: prefill })),
            contentMaxWidth: "max-w-3xl",
            isDismissable: true,
        }));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, buildingOptionsForForm, areaOptionsForForm, meters]);
    // Deep-link: auto-open create dialog with pre-filled values when
    // navigated to /dashboard/meters?create=1&buildingId=...&areaId=...&tenantId=...&tenantName=...&meterType=...
    (0, react_3.useEffect)(function () {
        if (autoCreateTriggered.current)
            return;
        if (searchParams.get("create") !== "1")
            return;
        // Wait until the form's option lists are populated so the dialog renders cleanly
        if (buildingOptionsForForm.length === 0)
            return;
        autoCreateTriggered.current = true;
        handleAddMeter({
            buildingId: searchParams.get("buildingId") || undefined,
            areaId: searchParams.get("areaId") || undefined,
            tenantId: searchParams.get("tenantId") || undefined,
            tenantName: searchParams.get("tenantName") || undefined,
            meterType: searchParams.get("meterType") || undefined,
        });
        // Clear the params from the URL so a browser refresh doesn't re-open the dialog
        setSearchParams({}, { replace: true });
    }, [searchParams, setSearchParams, handleAddMeter, buildingOptionsForForm.length]);
    var handleOpenMeter = (0, react_3.useCallback)(function (meterId) {
        navigate("/dashboard/meters/".concat(meterId));
    }, [navigate]);
    var handleEditMeter = (0, react_3.useCallback)(function (meterId) {
        navigate("/dashboard/meters/".concat(meterId, "?mode=edit"));
    }, [navigate]);
    /*
     * Meter Management Refinement: deleting a meter is now a status change to Inactive.
     *
     * Erik: "the active/inactive is the equivalent of delete. Meters should not be deleted (from UI)
     * since we need to always be able to see what happened in the past." The old flow here confirmed a
     * delete and then sent `meter_reading: 0` as an admitted placeholder, which is how every
     * status-change record in the database ended up holding a reading of nothing.
     *
     * It opens the dialog instead, which requires the reading the change happened on and the date that
     * reading was actually taken.
     */
    var handleChangeStatus = (0, react_3.useCallback)(function (meter) {
        setStatusChangeError(null);
        setStatusChangeMeter(meter);
    }, []);
    var handleConfirmStatusChange = (0, react_3.useCallback)(function (payload) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_2, message;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!statusChangeMeter || !userId)
                        return [2 /*return*/];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateMeter(__assign(__assign({ _id: statusChangeMeter._id, clientId: clientId }, payload), { 
                            /*
                             * A status change is a real-world event, not a correction of a mis-keyed field — the meter
                             * genuinely was in use until the effective date. `effectiveDate` here is the edit-history
                             * one, kept in step with the status change's own so the two records agree.
                             */
                            editClassification: "update", effectiveDate: payload.statusEffectiveDate, reason: "Status changed to ".concat(payload.status, ", on a reading of ").concat(payload.meter_reading, " taken ").concat(new Date(payload.statusReadingDate).toLocaleString("en-GB"), "."), lastModifiedBy: userId })).unwrap()];
                case 2:
                    response = _c.sent();
                    if (response.success) {
                        (0, react_1.addToast)({
                            title: "Meter is now ".concat(payload.status === "in-use" ? "in use" : payload.status),
                            description: "".concat(statusChangeMeter.serialNumber, " \u2014 recorded against a reading of ").concat(payload.meter_reading, "."),
                            color: "success",
                        });
                        setStatusChangeError(null);
                        setStatusChangeMeter(null);
                    }
                    else {
                        setStatusChangeError((_a = response.message) !== null && _a !== void 0 ? _a : "Could not change the meter's status.");
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _c.sent();
                    message = ((_b = error_2 === null || error_2 === void 0 ? void 0 : error_2.data) === null || _b === void 0 ? void 0 : _b.message) || "Could not change the meter's status.";
                    /*
                     * Deliberately NOT a toast, and the dialog stays open.
                     *
                     * The commonest failure here is a reading the register could not have produced, and the fix is
                     * to correct the number that is still on screen. Closing the dialog and flashing a toast would
                     * throw away everything the user had entered.
                     */
                    setStatusChangeError(message);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [statusChangeMeter, userId, clientId, updateMeter]);
    var handleRowsPerPageChange = function (keys) {
        if (keys !== "all") {
            var value = Array.from(keys)[0];
            setRowsPerPage(Number(value));
            setPage(1);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var renderCell = (0, react_3.useCallback)(function (meter, columnKey) {
        var _a, _b, _c;
        switch (columnKey) {
            case "meterId":
                return (0, jsx_runtime_1.jsx)("span", { className: "font-medium text-gray-900", children: meter.meterId || "#".concat(meter.meterNumber) });
            case "meterType":
                return ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: getMeterTypeColor(meter.meterType), children: meter.meterType }));
            case "serialNumber":
                return (0, jsx_runtime_1.jsx)("span", { className: "font-mono text-sm text-gray-700", children: meter.serialNumber });
            case "buildingName":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-700", children: (0, to_title_case_1.toTitleCase)(meter.buildingName) });
            case "meterPurpose":
                return meter.meterPurpose ? ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: (_a = constants_1.METER_PURPOSE_COLOURS[meter.meterPurpose]) !== null && _a !== void 0 ? _a : "default", children: (_b = constants_1.METER_PURPOSE_LABELS[meter.meterPurpose]) !== null && _b !== void 0 ? _b : meter.meterPurpose })) : ((0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-400", children: "Not set" }));
            case "meterDesignation": {
                /*
                 * The API composes this from the purpose — area name, service name, or check meter name —
                 * so the rule lives in one place. The fallbacks below are about what is MISSING, which is
                 * different per purpose: a production/bulk meter with no service is unconfigured work,
                 * whereas a consumption meter with no area is simply building level.
                 */
                if (meter.meterDesignation)
                    return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-700", children: meter.meterDesignation });
                var missing = meter.meterPurpose === "PRODUCTION_BULK" ? "No service assigned" : meter.meterPurpose === "CHECK" ? "Unnamed check meter" : "Building Level";
                var unconfigured = meter.meterPurpose === "PRODUCTION_BULK" || meter.meterPurpose === "CHECK";
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm ".concat(unconfigured ? "text-amber-600" : "text-gray-700"), children: missing });
            }
            case "tenantName":
                return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-700", children: meter.tenantName || "-" });
            case "responsibleParty":
                return ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: meter.responsibleParty === "Landlord" ? "primary" : "secondary", children: meter.responsibleParty }));
            case "meterMakeModel":
                return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-700", children: meter.meterMake }), (0, jsx_runtime_1.jsx)("span", { className: "text-xs text-gray-500", children: meter.meterModel })] }));
            case "kvaRating":
                return ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: "default", children: meter.kvaRating }));
            case "isManualReading":
                return ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: meter.isManualReading ? "warning" : "primary", children: meter.isManualReading ? "Manual" : "Auto" }));
            case "isActive":
                return ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: meter.status === "dormant" ? "warning" : meter.status === "removed" ? "danger" : meter.status === "inactive" ? "default" : "success", children: meter_1.METER_STATUS_LABELS[(_c = meter.status) !== null && _c !== void 0 ? _c : "in-use"] }));
            case "actions":
                return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "light", onPress: function () { return handleOpenMeter(meter._id); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:eye-linear", className: "text-lg text-gray-500" }) }), (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "light", onPress: function () { return handleEditMeter(meter._id); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:pen-linear", className: "text-lg text-gray-500" }) }), (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "light", title: "Change status", onPress: function () {
                                return handleChangeStatus({
                                    _id: meter._id,
                                    serialNumber: meter.serialNumber,
                                    meterType: meter.meterType,
                                    status: meter.status,
                                    isManualReading: meter.isManualReading,
                                });
                            }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:flag-linear", className: "text-lg text-gray-500" }) })] }));
            default:
                return null;
        }
    }, [handleOpenMeter, handleEditMeter, handleChangeStatus]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 md:gap-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "rounded-xl bg-white p-4 shadow-sm md:p-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-xl font-semibold text-gray-900 md:text-2xl", children: "Meters Management" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:add-circle-linear", className: "text-lg" }), onPress: function () { return handleAddMeter(); }, className: "flex-1 sm:flex-none", children: "Add Meter" }), (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, variant: "light", onPress: handleRefresh, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:refresh-linear", className: "text-xl text-gray-600" }) })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "mt-4 flex flex-col gap-4 md:mt-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Search meters...", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:magnifer-linear", className: "text-gray-400" }), value: searchQuery, onValueChange: setSearchQuery, variant: "bordered", size: "sm" }), [
                                        { label: "Building", value: buildingFilter, set: setBuildingFilter, options: buildingFilterOptions },
                                        { label: "Area", value: areaFilter, set: setAreaFilter, options: areaFilterOptions },
                                        { label: "Tenant", value: tenantFilter, set: setTenantFilter, options: tenantFilterOptions },
                                        { label: "Make", value: makeFilter, set: setMakeFilter, options: __spreadArray([{ key: "all", label: "All makes" }], makeOptions.map(function (v) { return ({ key: v, label: v }); }), true) },
                                        { label: "Model", value: modelFilter, set: setModelFilter, options: __spreadArray([{ key: "all", label: "All models" }], modelOptions.map(function (v) { return ({ key: v, label: v }); }), true) },
                                        { label: "Rate Card", value: rateCardFilter, set: setRateCardFilter, options: __spreadArray([{ key: "all", label: "All rate cards" }], rateCardOptions.map(function (v) { return ({ key: v, label: v }); }), true) },
                                    ].map(function (f) { return (
                                    /* Searchable, per the ticket — a portfolio has more areas and rate cards than a plain list handles. */
                                    (0, jsx_runtime_1.jsx)(react_1.Autocomplete, { disableAnimation: true, size: "sm", variant: "bordered", label: f.label, placeholder: "Search ".concat(f.label.toLowerCase(), "..."), selectedKey: f.value, onSelectionChange: function (key) {
                                            if (key == null)
                                                return;
                                            f.set(String(key));
                                            setPage(1);
                                        }, popoverProps: { classNames: { content: "z-[70]" } }, listboxProps: { className: "max-h-[220px] overflow-auto" }, children: f.options.map(function (o) { return ((0, jsx_runtime_1.jsx)(react_1.AutocompleteItem, { textValue: o.label, children: o.label }, o.key)); }) }, f.label)); })] }), (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-1 gap-x-4 gap-y-3 md:grid-cols-2 xl:grid-cols-3", children: [(0, jsx_runtime_1.jsx)(tile_filter_1.TileFilter, { title: "Service Type", icon: "solar:box-linear", options: countBy("service", serviceTypeOf, serviceTypeValues.map(function (v) { return ({ key: v, label: v }); })), selected: serviceKeys, onChange: function (next) {
                                            setServiceKeys(next);
                                            setPage(1);
                                        } }), (0, jsx_runtime_1.jsx)(tile_filter_1.TileFilter, { title: "Status", icon: "solar:power-linear", options: countBy("status", function (m) { var _a; return (_a = m.status) !== null && _a !== void 0 ? _a : "in-use"; }, [
                                            { key: "in-use", label: meter_1.METER_STATUS_LABELS["in-use"] },
                                            { key: "dormant", label: meter_1.METER_STATUS_LABELS.dormant },
                                            { key: "removed", label: meter_1.METER_STATUS_LABELS.removed },
                                            { key: "inactive", label: meter_1.METER_STATUS_LABELS.inactive },
                                        ]), selected: statusKeys, onChange: function (next) {
                                            setStatusKeys(next);
                                            setPage(1);
                                        } }), (0, jsx_runtime_1.jsx)(tile_filter_1.TileFilter, { title: "Assignment", icon: "solar:link-linear", options: countBy("assignment", assignmentOf, [
                                            { key: "Assigned", label: "Assigned" },
                                            { key: "Unassigned", label: "Unassigned" },
                                        ]), selected: assignmentKeys, onChange: function (next) {
                                            setAssignmentKeys(next);
                                            setPage(1);
                                        } }), (0, jsx_runtime_1.jsx)(tile_filter_1.TileFilter, { title: "Type", icon: "solar:bolt-linear", options: countBy("type", function (m) { return m.meterType; }, [
                                            { key: "Power", label: "Power" },
                                            { key: "Water", label: "Water" },
                                        ]), selected: typeKeys, onChange: function (next) {
                                            setTypeKeys(next);
                                            setPage(1);
                                        } }), (0, jsx_runtime_1.jsx)(tile_filter_1.TileFilter, { title: "Purpose", icon: "solar:target-linear", options: countBy("purpose", purposeOf, [
                                            { key: "Consumption", label: "Consumption" },
                                            { key: "Check", label: "Check" },
                                            { key: "Production/Bulk", label: "Production/Bulk" },
                                            { key: "Not set", label: "Not set" },
                                        ]), selected: purposeKeys, onChange: function (next) {
                                            setPurposeKeys(next);
                                            setPage(1);
                                        } }), (0, jsx_runtime_1.jsx)(tile_filter_1.TileFilter, { title: "Level", icon: "solar:layers-linear", options: countBy("level", function (m) { return m.meterLevel; }, [
                                            { key: "area", label: "Area" },
                                            { key: "building", label: "Building" },
                                        ]), selected: levelKeys, onChange: function (next) {
                                            setLevelKeys(next);
                                            setPage(1);
                                        } })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2 text-sm text-gray-500", children: ["Total Meters: ", (0, jsx_runtime_1.jsx)("span", { className: "font-semibold text-gray-700", children: totalItems }), isFetching && !isLoading && (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "sm" })] })] })] }), (0, jsx_runtime_1.jsx)(onboarding_gaps_prompt_1.OnboardingGapsPrompt, { buildingId: buildingFilter !== "all" ? buildingFilter : undefined }), (0, jsx_runtime_1.jsx)("div", { className: "overflow-hidden rounded-xl bg-white shadow-sm", children: (0, jsx_runtime_1.jsx)("div", { className: "overflow-x-auto", children: (0, jsx_runtime_1.jsxs)(react_1.Table, { "aria-label": "Meters table", classNames: table_styles_1.DATA_TABLE_CLASS_NAMES, bottomContent: (0, jsx_runtime_1.jsxs)("div", { className: "flex w-full flex-col gap-3 border-t border-gray-100 px-3 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-4 sm:py-4", children: [(0, jsx_runtime_1.jsxs)("span", { className: "text-center text-xs text-gray-500 sm:text-left sm:text-sm", children: ["Showing ", totalItems === 0 ? 0 : (page - 1) * rowsPerPage + 1, " to ", Math.min(page * rowsPerPage, totalItems), " of ", totalItems, " meters"] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center gap-3 sm:flex-row sm:gap-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-xs text-gray-500 sm:text-sm", children: "Rows:" }), (0, jsx_runtime_1.jsx)(react_1.Select, { className: "w-16 sm:w-20", size: "sm", variant: "bordered", selectedKeys: [String(rowsPerPage)], onSelectionChange: handleRowsPerPageChange, "aria-label": "Rows per page", children: constants_1.rowsPerPageOptions.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: option.label }, option.key)); }) })] }), totalPages > 1 && ((0, jsx_runtime_1.jsx)(react_1.Pagination, { isCompact: true, showControls: true, showShadow: true, color: "primary", page: page, total: totalPages, onChange: setPage, size: "sm" }))] })] }), children: [(0, jsx_runtime_1.jsx)(react_1.TableHeader, { columns: constants_1.columns, children: function (column) { return ((0, jsx_runtime_1.jsx)(react_1.TableColumn, { align: column.uid === "actions" ? "center" : "start", children: column.name }, column.uid)); } }), (0, jsx_runtime_1.jsx)(react_1.TableBody, { items: meters, emptyContent: isLoading || isFetching ? " " : "No meters found", isLoading: isLoading || isFetching, loadingContent: (0, jsx_runtime_1.jsx)(react_1.Spinner, { label: "Loading meters..." }), children: function (item) { return (0, jsx_runtime_1.jsx)(react_1.TableRow, { children: function (columnKey) { return (0, jsx_runtime_1.jsx)(react_1.TableCell, { children: renderCell(item, columnKey) }); } }, item._id); } })] }) }) }), statusChangeMeter && ((0, jsx_runtime_1.jsx)(meter_status_change_dialog_1.MeterStatusChangeDialog, { isOpen: true, onClose: function () {
                    setStatusChangeError(null);
                    setStatusChangeMeter(null);
                }, clientId: clientId, meter: statusChangeMeter, isSaving: isChangingStatus, errorMessage: statusChangeError, onConfirm: handleConfirmStatusChange }))] }));
}
